module.exports = __webpack_public_path__ + "img/removeImg.d500129d.svg";